<template>
  <div class="el_container">
    <div class="ly_title">
      <div class="el_title">{{ title }}</div>
      <div class="el_progress">{{ culProgress }}</div>
      <progress-bar
        :progress="culProgress"
        :is-finish="isFinished"
      ></progress-bar>
    </div>
    <div class="el_question_text">
      {{ questions[$route.params.id - 1].description }}
    </div>
    <div class="ly_img_content">
      <img class="el_img_size" :src="imgSrc" />
    </div>
    <div class="ly_ans">回答</div>
    <div v-if="view">
      <div
        class="ly_radio_buttons"
        v-for="(question, question_index) in questions[$route.params.id - 1].questions"
        v-bind:key="question.id"
      >
        <div :class="`ly_radio_${question_index % 2}`">
          <div class="ly_radio_text"><span>[{{ question.id }}]</span><span>{{ question.label }}</span></div>
          <material-radio-button
            :id="$route.params.id"
            :problem_id="question.id"
            class="ly_radio_button"
            @selected="updateJson(question, $event)"
          ></material-radio-button
          ><br />
        </div>
      </div>
    </div>
    <Navigator
      @onTransition="transit($event)"
      :enableGo="answerCompleted"
    />
  </div>
</template>

<script>
import MaterialButton from '../atoms/MaterialButton'
import MaterialRadioButton from '../atoms/MaterialRadioButton'
import questions from '../../assets/psychologytest1.json'
import ProgressBar from '../atoms/ProgressBar'
import Navigator from '../molcules/Navigator'

export default {
  name: 'Problem',
  components: {
    ProgressBar,
    MaterialRadioButton,
    MaterialButton,
    Navigator,
  },
  data: () => ({
    questions: questions,
    answerCompleted: false,
    view: true,
  }),
  computed: {
    culProgress() {
      const val = parseInt(this.$route.params.id) * 4
      return val + '%'
    },
    title() {
      return '状況' + this.$route.params.id
    },
    imgSrc() {
      return require('../../assets/psychologytest1/' +
        this.$route.params.id +
        '.png')
    },
  },
  methods: {
    transit(to) {
      // console.log(to)
      this.reset()
    },
    reset() {
      this.view = false
      this.answerCompleted = false
      this.$nextTick(() => {
        this.view = true
      })
    },
    updateJson(question, value) {
      this.questions[this.$route.params.id - 1].questions[
        question.id - 1
      ].answer = value
      this.$store.commit('saveAnswer', this.questions)
      this.checkAnswerCompleted()
    },
    // 全ての回答が「未回答」以外となれば、回答完了。
    checkAnswerCompleted() {
      const questions = this.$store.state.answer[this.$route.params.id - 1].questions
      // console.log(questions)
      this.answerCompleted = questions.reduce((result, current) => result && current.answer != 2, true)
      // console.log(this.answerCompleted)
    },
  },
}
</script>

<style scoped>
.el_container {
  padding: 0px 10% 0px 10%;
}
.ly_title {
  display: flex;
  position: relative;
  top: 48px;
  justify-content: space-between;
}
.el_progress {
  position: relative;
  top: 18px;
  margin-left: auto;
  margin-right: 10px;
}
.el_title {
  position: relative;
  width: 117px;
  height: 53px;
  text-align: left;
  font-size: 36px;
  color: #6b6b6b;
}

.el_question_text {
  position: relative;
  width: 100%;
  height: 84px;
  top: 74px;
  text-align: left;

  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;

  color: #6b6b6b;
}

.ly_img_content {
  display: flex;
  position: relative;
  top: 68px;
}

.el_img_size {
  width: 100%;
}

.ly_ans {
  position: relative;
  text-align: left;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;

  color: #6b6b6b;

  width: 58px;
  height: 41px;
  top: 98px;
}

.ly_radio_buttons {
  position: relative;
  top: 90px;
  width: 800px;
}

.ly_radio {
  display: flex;
  /* margin-top: 28px; */
  padding: 14px;
}
.ly_radio_0 {
  display: flex;
  /* margin-top: 28px; */
  padding: 14px;
}
.ly_radio_1 {
  display: flex;
  /* margin-top: 28px; */
  padding: 14px;
  background-color: #fafafa;
}

.ly_radio_text {
  align-self: flex-start;
  text-align: left;
}

.ly_radio_text span {
  margin-left: 1em;
  /* text-indent: 1em; */
  /* padding-left: 1.3em; */
}

.ly_radio_button {
  margin-left: auto;
}

.ly_button {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 130px;
  padding-bottom: 44px;
}

.ly_next_button {
  position: relative;
  text-align: end;
  width: 100%;
  top: 130px;
  padding-bottom: 44px;
}
</style>
